export default __webpack_public_path__ + "static/media/ElectricityIsEverywhere_08.5750c4fd.png";